"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _ActiveSpeakerIndicator = require("./ActiveSpeakerIndicator.js");
Object.keys(_ActiveSpeakerIndicator).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _ActiveSpeakerIndicator[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _ActiveSpeakerIndicator[key];
    }
  });
});